export var CREDIT_NOTE_STATUS_ENUMS;
(function (CREDIT_NOTE_STATUS_ENUMS) {
    CREDIT_NOTE_STATUS_ENUMS["DRAFT"] = "DRAFT";
    CREDIT_NOTE_STATUS_ENUMS["CLOSED"] = "CLOSED";
    // OPEN = "OPEN",
    // ISSUED = "ISSUED",
    // PARTIALLY_APPLIED = "PARTIALLY_APPLIED",
    // VOID = "VOID",
    // EXPIRED = "EXPIRED",
    CREDIT_NOTE_STATUS_ENUMS["ARCHIVED"] = "ARCHIVED";
})(CREDIT_NOTE_STATUS_ENUMS || (CREDIT_NOTE_STATUS_ENUMS = {}));
//# sourceMappingURL=creditNote.js.map